import { render, staticRenderFns } from "./ReviewDeskItem.vue?vue&type=template&id=1407d357"
import script from "./ReviewDeskItem.vue?vue&type=script&lang=js"
export * from "./ReviewDeskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports